const KeenSlider = window.KeenSlider

const { setInitialised, useA11y, useDots } = window.BAO.Carousel.plugins

class ProductMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    const carousel = new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 768px)': {
            disabled: true,
          },
        },
      },
      [
        setInitialised(),
        useA11y({
          instructions: null,
          includeRegion: false,
          includeRoleDescription: false,
          includeTabindex: false,
        }),
        useDots(this.els?.dot?.elements),
      ],
    )

    return carousel
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
